import { render, staticRenderFns } from "./SuggestedStartups.vue?vue&type=template&id=87960dbe&scoped=true&"
import script from "./SuggestedStartups.vue?vue&type=script&setup=true&lang=js&"
export * from "./SuggestedStartups.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87960dbe",
  null
  
)

export default component.exports